module.exports = __webpack_public_path__ + "img/content1.6aad90ad.png";